'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidCompass = function IoAndroidCompass(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 18c1 0 2 1 2 2s-1 2-2 2-2-1-2-2 1-2 2-2z m0-15.5c9.6 0 17.5 7.9 17.5 17.5s-7.9 17.5-17.5 17.5-17.5-7.9-17.5-17.5 7.9-17.5 17.5-17.5z m3.8 21.3l6.7-14.3-14.3 6.7-6.7 14.3z' })
        )
    );
};

exports.default = IoAndroidCompass;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-compass.js
// module id = 1845
// module chunks = 0